/* unplugin-vue-components disabled */import script from "./OrderStatusCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderStatusCard.vue?vue&type=script&setup=true&lang=js"

import "./OrderStatusCard.vue?vue&type=style&index=0&id=c4f0c0c0&lang=scss"

const __exports__ = script;

export default __exports__